<template>
    <div class="entity-manager" v-loading="loading">
        <Page title="实体信息管理">
            <div class="row-container">
                <div class="col-container" style="flex: 1; min-height: 500px; min-width: 350px">
                    <Card :no-border="false">
                        <template #header>
                            <div class="card-header">
                                <h4>实体列表</h4>
                                <div class="buttons">
                                    <el-button @click="removeEntity" icon="el-icon-delete" size="mini" type="danger"> 删除实体 </el-button>
                                    <el-button @click="handleAddEntity" icon="el-icon-plus" size="mini" type="primary"> 新建实体 </el-button>
                                </div>
                            </div>
                        </template>
                        <div style="padding: 10px">
                            <el-input placeholder="输入关键字进行过滤" v-model="filterText"></el-input>
                        </div>
                        <el-tree
                            class="my-tree"
                            ref="tree"
                            style="margin-top: 5px"
                            :data="treeData"
                            node-key="EntityID"
                            :current-node-key="currentEntityId"
                            default-expand-all
                            highlight-current
                            :expand-on-click-node="false"
                            :filter-node-method="filterNode"
                            @node-click="handleNodeClick"
                        >
                            <template #default="{ data }">
                                <div class="custom-tree-node">
                                    <span class="menu-icon icon-shop" v-if="data.EntityType == 1"></span>
                                    <span class="menu-icon icon-floor" v-if="data.EntityType == 2"></span>
                                    <span class="menu-icon icon-market" v-if="data.EntityType == 3"></span>
                                    <span class="menu-icon icon-org" v-if="data.EntityType == 101"></span>
                                    <span>{{ data.EntityName }}</span>
                                </div>
                            </template>
                        </el-tree>
                    </Card>
                </div>
                <div style="margin-left: 10px; flex: 2; min-width: 750px">
                    <div class="col-container">
                        <Card :no-border="false">
                            <template #header>
                                <div class="card-header">
                                    <h4>基础信息</h4>
                                    <div class="buttons">
                                        <el-button @click="updateEntity" icon="el-icon-edit-outline" size="mini" type="warning">修改实体 </el-button>
                                    </div>
                                </div>
                            </template>
                            <el-form style="padding-left: 10px" :show-message="false" label-width="80px" label-position="left">
                                <el-row :gutter="10">
                                    <el-col :span="8">
                                        <el-form-item label="编号:" prop="EntityID">
                                            <span><Guid :text="currentEntity.EntityID"></Guid></span>
                                        </el-form-item>
                                    </el-col>
                                </el-row>
                                <el-row :gutter="10">
                                    <el-col :span="8">
                                        <el-form-item label="名称" prop="EntityName">
                                            <span>{{ currentEntity.EntityName }}</span>
                                        </el-form-item>
                                    </el-col>
                                    <el-col :span="8">
                                        <el-form-item :label="currentEntity.EntityType == 2 ? '楼层:' : '编码'" prop="name">
                                            <span>{{ currentEntity.EntityCodeEx }}</span>
                                        </el-form-item>
                                    </el-col>
                                    <el-col :span="8">
                                        <el-form-item label="类型:" prop="EntityType">
                                            <span v-if="currentEntity.EntityType == 3">商场</span>
                                            <span v-if="currentEntity.EntityType == 2">楼层</span>
                                            <span v-if="currentEntity.EntityType == 1">店铺</span>
                                            <span v-if="currentEntity.EntityType == 101">机构</span>
                                        </el-form-item>
                                    </el-col>
                                    <el-col :span="8" v-if="currentEntity.EntityType !== 0">
                                        <el-form-item label="面积:" prop="Acreage">
                                            <span>{{ currentEntity.Acreage }}</span>
                                        </el-form-item>
                                    </el-col>
                                    <template v-if="currentEntity.EntityType == 3 || currentEntity.EntityType == 1">
                                        <el-col :span="8">
                                            <el-form-item label="创建时间:" prop="CreatedTime">
                                                <span>{{ formatTime(currentEntity.CreatedTime, "YYYY-MM-DD") }}</span>
                                            </el-form-item>
                                        </el-col>
                                        <el-col :span="8">
                                            <el-form-item label="营业时间:">
                                                <span>{{ bizTime }}</span>
                                            </el-form-item>
                                        </el-col>
                                    </template>
                                    <el-col :span="8">
                                        <el-form-item label="联系人:" prop="Linkman">
                                            <span>{{ currentEntity.Linkman }}</span>
                                        </el-form-item>
                                    </el-col>
                                    <el-col :span="8">
                                        <el-form-item label="联系电话:" prop="Phone">
                                            <span>{{ currentEntity.Phone }}</span>
                                        </el-form-item>
                                    </el-col>
                                    <el-col :span="24" v-if="currentEntity && currentEntity.EntityType < 100">
                                        <el-form-item label="位置坐标:" prop="Location">
                                            <span class="link-text" @click="showSetLocation">
                                                <template v-if="!currentEntity.Location">未设置</template>
                                                <template v-else>
                                                    lng:{{ currentEntity.Location.lng }}, lat:{{ currentEntity.Location.lat }}
                                                </template>
                                            </span>

                                            <span class="link-button" v-if="currentEntity.Location" @click="clearLocation"> 清除 </span>
                                        </el-form-item>
                                    </el-col>
                                </el-row>
                            </el-form>
                        </Card>
                    </div>
                    <div class="col-container" style="margin-top: 10px" v-if="currentEntity && currentEntity.EntityType < 100">
                        <Card :no-border="false">
                            <template #header>
                                <div class="card-header">
                                    <h4>出入口</h4>
                                    <div class="buttons">
                                        <el-button @click="bindNewDoor" size="mini" type="primary">新建出入口</el-button>
                                        <el-button @click="bindDoorVisible = true" size="mini" type="primary">添加已有出入口 </el-button>
                                    </div>
                                </div>
                            </template>
                            <div style="padding: 10px">
                                <el-table size="mini" :data="doorList" @row-click="rowClick" :row-class-name="tableRowClassName">
                                    <el-table-column prop="DoorID" label="编号">
                                        <template #default="{ row }">
                                            <Guid :text="row.DoorID"></Guid>
                                        </template>
                                    </el-table-column>
                                    <el-table-column prop="DoorName" label="名称"></el-table-column>
                                    <el-table-column prop="Direction" label="方向">
                                        <template #default="{ row }">
                                            <span v-if="row.Direction == 1">正向</span>
                                            <span v-else>反向</span>
                                        </template>
                                    </el-table-column>
                                    <el-table-column label="操作" width="350px">
                                        <template #default="{ row }">
                                            <el-button @click.stop="bindDevice(row)" icon="el-icon-plus" size="mini" type="warning"
                                                >绑定设备
                                            </el-button>
                                            <el-button @click.stop="changeDir(row)" icon="el-icon-refresh-left" size="mini" type="warning"
                                                >更改方向
                                            </el-button>
                                            <el-button @click.stop="delDoor(row)" icon="el-icon-delete" size="mini" type="danger">删除 </el-button>
                                            <el-button v-if="false" size="mini" type="success">更多</el-button>
                                        </template>
                                    </el-table-column>
                                </el-table>
                            </div>
                        </Card>
                    </div>
                    <div class="col-container" style="margin-top: 10px" v-if="currentEntity && currentEntity.EntityType < 100">
                        <Card :no-border="false">
                            <template #header>
                                <div class="card-header">
                                    <h4>设备列表</h4>
                                </div>
                            </template>
                            <div style="padding: 10px">
                                <el-table size="mini" :data="filterDeviceList">
                                    <el-table-column prop="DeviceID" label="编号">
                                        <template #default="{ row }">
                                            <Guid :text="row.DeviceID"></Guid>
                                        </template>
                                    </el-table-column>
                                    <el-table-column prop="DeviceSN" label="序列号"></el-table-column>
                                    <el-table-column prop="DeviceName" label="别名"></el-table-column>
                                    <el-table-column prop="DoorName" label="所在出入口"></el-table-column>
                                    <el-table-column width="150px" label="操作">
                                        <template #default="{ row }">
                                            <el-button @click="handleRemoveDevice(row)" size="mini" type="danger">移除 </el-button>
                                            <el-button v-if="false" size="mini" type="success">更多</el-button>
                                        </template>
                                    </el-table-column>
                                </el-table>
                            </div>
                        </Card>
                    </div>
                    <div class="col-container" style="margin-top: 10px" v-if="currentEntity && currentEntity.EntityType < 100">
                        <FlowWarnPolicy :id="currentEntityId"></FlowWarnPolicy>
                    </div>
                </div>
            </div>
        </Page>
        <BandNewDoor
            v-if="bindNewDoorVisible"
            :entity-id="currentEntityId"
            @refresh="getEntityDoorsByEntityId"
            v-model:visible="bindNewDoorVisible"
        ></BandNewDoor>
        <AddEntity
            v-if="addVisible"
            v-model:visible="addVisible"
            :update-entity="transEntity"
            :show-id="currentEntityId"
            @refresh="getOrgTree"
            @update="getEntityInfo"
        ></AddEntity>
        <BandDoor
            v-if="bindDoorVisible"
            :exist-list="doorList"
            :entity-id="currentEntityId"
            v-model:visible="bindDoorVisible"
            @refresh="getEntityDoorsByEntityId"
        ></BandDoor>
        <BindDevice @close="showDeviceDialog = false" v-if="showDeviceDialog" :show="showDeviceDialog" @save="saveDevice"></BindDevice>
        <MapSelectLocation
            v-if="showSelectLocation"
            @save="onSaveLocation"
            @close="showSelectLocation = false"
            :show="showSelectLocation"
            :point="point"
        ></MapSelectLocation>
    </div>
</template>

<script>
import dayjs from "dayjs";
import BandNewDoor from "./components/BandNewDoor";
import AddEntity from "./components/AddEntity";
import BandDoor from "./components/BandDoor";
import BindDevice from "./components/BindDevice.vue";
import FlowWarnPolicy from "./components/FlowWarnPolicy.vue";
import MapSelectLocation from "../../components/MapSelectLocation.vue";

export default {
    name: "Entity",
    components: {
        BandNewDoor,
        AddEntity,
        BandDoor,
        BindDevice,
        FlowWarnPolicy,
        MapSelectLocation,
    },
    data() {
        return {
            loading: true,
            queryStyle: 1,
            treeData: [],
            filterText: "",
            addVisible: false,
            currentEntityId: "",
            showSelectLocation: false,
            point: null,
            currentEntity: {
                EntityCode: "",
                EntityName: "",
                EntityType: 100,
                CreatedUserID: "",
                CreatedTime: "",
                BizTime: "",
                Linkman: "",
                Phone: "",
            },
            transEntity: null,
            deviceList: [],
            doorList: [],
            bindNewDoorVisible: false,
            bindDoorVisible: false,
            showDeviceDialog: false,
            selectedDoor: null,
            // 行选择出入口
            selectRow: null,
            showEditLocationDialog: false,
        };
    },
    computed: {
        bizTime() {
            let beginHour =
                Number.parseInt(this.currentEntity.BizTimeBeginHour) < 10
                    ? "0" + this.currentEntity.BizTimeBeginHour
                    : this.currentEntity.BizTimeBeginHour;
            let beginMin =
                Number.parseInt(this.currentEntity.BizTimeBeginMin) < 10
                    ? "0" + this.currentEntity.BizTimeBeginMin
                    : this.currentEntity.BizTimeBeginMin;
            let endHour =
                Number.parseInt(this.currentEntity.BizTimeEndHour) < 10 ? "0" + this.currentEntity.BizTimeEndHour : this.currentEntity.BizTimeEndHour;
            let endMin =
                Number.parseInt(this.currentEntity.BizTimeEndMin) < 10 ? "0" + this.currentEntity.BizTimeEndMin : this.currentEntity.BizTimeEndMin;
            return beginHour + ":" + beginMin + "-" + endHour + ":" + endMin;
        },
        filterDeviceList() {
            if (this.selectRow) {
                return this.deviceList.filter((item) => item.DoorName === this.selectRow.DoorName);
            }
            return this.deviceList;
        },
    },
    methods: {
        showEditLocations() {
            this.showEditLocationDialog = true;
        },
        clearLocation() {
            this.$myConfirm().then(() => {
                this.$ajax.post("/Entity/ClearEntityLocation?id=" + this.currentEntityId).then((res) => {
                    this.$message.success("操作成功");
                    this.getEntityInfo();
                });
            });
        },
        showSetLocation() {
            if (this.currentEntity != null) {
                this.point = this.currentEntity.Location;
                this.showSelectLocation = true;
            }
        },
        onSaveLocation(point) {
            this.$ajax.post("/Entity/SaveEntityLocation", { ID: this.currentEntity.EntityID, Location: point }).then((result) => {
                this.showSelectLocation = false;
                this.getEntityInfo();
            });
        },
        getOrgTree(entityId = null) {
            this.$ajax
                .post("/Entity/GetEntityTree")
                .then((result) => {
                    this.loading = false;
                    if (result.Data) {
                        this.treeData = [...result.Data];
                        if (entityId) {
                            this.$nextTick(() => {
                                this.currentEntityId = entityId;
                                this.$refs["tree"].setCurrentKey(entityId);
                            });
                        } else {
                            this.currentEntityId = result.Data[0].EntityID;
                            this.$nextTick(() => {
                                this.$refs["tree"].setCurrentKey(result.Data[0].EntityID);
                            });
                        }
                    }
                })
                .catch((err) => {
                    this.loading = false;
                });
        },
        filterNode(value, data) {
            if (!value) return true;
            console.log(data);
            return data.Name.includes(value);
        },
        getDeviceByEntityId() {
            this.$ajax
                .post(`/Entity/GetEntityDevices?id=${this.currentEntityId}`)
                .then((res) => {
                    if (res.Data) {
                        this.deviceList = [...res.Data];
                    }
                })
                .catch((err) => {
                    console.log(err);
                });
        },
        getEntityDoorsByEntityId() {
            this.$ajax
                .post(`/Entity/GetEntityDoors?id=${this.currentEntityId}`)
                .then((res) => {
                    if (res.Data) {
                        this.doorList = [...res.Data];
                    }
                })
                .catch((err) => {
                    console.log(err);
                });
        },

        handleNodeClick(data) {
            this.$nextTick(() => {
                this.$refs["tree"].setCurrentKey(data.EntityID);
                this.currentEntityId = data.EntityID;
            });
        },
        formatTime(time, format) {
            return dayjs(time).format(format);
        },
        handleAddEntity() {
            this.transEntity = null;
            this.addVisible = true;
        },
        updateEntity() {
            this.transEntity = { ...this.currentEntity };
            this.addVisible = true;
        },
        removeEntity() {
            if (this.currentEntityId) {
                this.$myConfirm().then(() => {
                    this.$ajax.post(`/Entity/RemoveEntity?id=${this.currentEntityId}`).then((res) => {
                        this.$message.success("操作成功");
                        this.getOrgTree();
                    });
                });
            } else {
                this.$message.error("请选择实体");
            }
        },
        bindNewDoor() {
            this.bindNewDoorVisible = true;
        },
        handleRemoveDevice(data) {
            this.$myConfirm().then(() => {
                this.$ajax.post("/Entity/UnBindDevice", { DeviceID: data.DeviceID, DoorID: data.DoorID }).then((res) => {
                    this.$message.success("操作成功");
                    this.getDeviceByEntityId();
                });
            });
        },
        getEntityInfo() {
            this.transEntity = null;
            this.$ajax.post(`/Entity/GetEntity?id=${this.currentEntityId}`).then((res) => {
                this.currentEntity = { ...res.Data };
            });
        },
        bindDevice(row) {
            this.selectedDoor = row;
            this.showDeviceDialog = true;
            console.log(row);
        },
        saveDevice(data) {
            if (data.DeviceID != "") {
                data.DoorID = this.selectedDoor.DoorID;
                this.$ajax.post("/Entity/BindDevice", data).then((res) => {
                    this.$success("操作成功");
                    this.getDeviceByEntityId();
                    this.showDeviceDialog = false;
                });
            } else {
                data.DoorID = this.selectedDoor.DoorID;
                this.$ajax.post("/Entity/BindNewDevice", data).then((res) => {
                    this.$success("操作成功");
                    this.getDeviceByEntityId();
                    this.showDeviceDialog = false;
                });
            }
        },
        changeDir(row) {
            let params = { ...row, Direction: row.Direction == 1 ? 0 : 1 };
            this.$myConfirm().then(() => {
                this.$ajax.post("/Entity/ChangeDirection", params).then((res) => {
                    this.$message.success("操作成功");
                    this.getEntityDoorsByEntityId();
                });
            });
        },
        delDoor(row) {
            this.$myConfirm().then(() => {
                this.$ajax.post(`/Entity/UnBindDoor`, row).then((res) => {
                    this.$message.success("操作成功");
                    this.getEntityDoorsByEntityId();
                    this.getDeviceByEntityId();
                });
            });
            console.log(row);
        },
        tableRowClassName({ row, rowIndex }) {
            if (row === this.selectRow) {
                return "success-row";
            }
            return "";
        },
        rowClick(row) {
            if (!this.selectRow || row !== this.selectRow) {
                this.selectRow = row;
            } else {
                this.selectRow = null;
            }
        },
    },
    created() {
        this.getOrgTree();
    },
    watch: {
        currentEntityId(newVal, oldVal) {
            this.getEntityInfo();
            this.getDeviceByEntityId();
            this.getEntityDoorsByEntityId();
        },
        filterText(val) {
            this.$refs.tree.filter(val);
        },
    },
};
</script>
<style>
.el-table .success-row {
    background: #f5f7fa;
}
</style>

<style scoped>
.custom-tree-node .menu-icon {
    width: 20px;
    position: relative;
}

.entity-manager .el-form-item {
    margin-bottom: 0;
}

.entity-manager .menu-icon {
    width: 20px;
    position: relative;
}

.entity-manager .active {
    background-color: #f0f7ff;
}
</style>
